import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { PRODUCT_IMAGE } from '../data/content';
const includes = ['The complete master clinical guide — 170 pages', '105 goals · 56 activities · 32 therapy blueprints', '5 premium bonus resources', 'Pediatric + adult resources', 'Instant digital access'];
export function Offer() {
  return <section id="offer" className="bg-navy-deep py-12 sm:py-16" aria-labelledby="offer-title" data-id="element-119" data-mp="tylglr1tuctm">
      <div className="mx-auto max-w-3xl px-5 text-center sm:px-8" data-id="element-120" data-mp="p00d9ira3d0y">
        <h2 id="offer-title" className="font-display text-[28px] font-semibold uppercase leading-tight tracking-tightish text-ivory-light sm:text-4xl" data-id="element-121" data-mp="p1v052m41f7o">
          Speech Therapy Clinical Toolkit™
        </h2>
        <p className="mt-2 text-[12.5px] font-semibold uppercase tracking-[0.12em] text-sage sm:text-sm" data-id="element-122" data-mp="2fbogi81spihz">
          The complete professional speech therapy system
        </p>

        <img src={PRODUCT_IMAGE} alt="Everything included in the Speech Therapy Clinical Toolkit system" className="mx-auto mt-5 w-full max-w-[420px] sm:mt-7" loading="lazy" data-id="element-123" data-mp="pk7fxlpl6l9g" />

        <ul className="mx-auto mt-6 grid max-w-sm gap-2 text-left sm:mt-8 sm:max-w-md" data-id="element-124" data-mp="zhvdskiho8vu">
          {includes.map(item => <li key={item} className="flex items-start gap-2.5 text-[14px] leading-snug text-ivory/85 sm:text-base" data-id="element-125" data-mp="13ip0xbo3xjno">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-sage" aria-hidden="true" data-id="element-126" data-mp="bskhbf8690ni" />
              {item}
            </li>)}
        </ul>

        <p className="mt-8 text-[12px] font-semibold uppercase tracking-[0.2em] text-gold-light sm:text-sm" data-id="element-127" data-mp="fsukyl8hrez7">
          Today
        </p>
        <p className="font-display text-[92px] font-semibold leading-[0.85] text-ivory-light sm:text-[140px]" data-id="element-128" data-mp="3k8m0kt4ww121">
          $27
        </p>
        <p className="mt-3 text-[11.5px] font-semibold uppercase tracking-[0.16em] text-ivory/55 sm:text-xs" data-id="element-129" data-mp="3o95yhyxb78p8">
          USD — one-time payment
        </p>

        <div className="mx-auto mt-7 max-w-md" data-id="element-130" data-mp="qgnr8ff7p2j6">
          <CtaButton href="https://speechtherapyclinicaltoolkit.impultienda.ar/checkout" variant="gold" tone="dark" microcopy="Instant digital access • 7-day guarantee" data-id="element-131" data-mp="qfurhyeo7daj">
            Get instant access
          </CtaButton>
        </div>
      </div>
    </section>;
}